module.exports = __webpack_public_path__ + "img/Lego_Kids_cs.4e54389c.png";